module.exports = __webpack_public_path__ + "static/media/FinX Kotak Brochure_ 21 April_compressed.645ba443.pdf";